export default __webpack_public_path__ + "static/media/Bolos-De-Berlim.1085c523.jpg";